import { render, staticRenderFns } from "./NewSliderImg.vue?vue&type=template&id=5c07efa6&"
import script from "./NewSliderImg.vue?vue&type=script&lang=js&"
export * from "./NewSliderImg.vue?vue&type=script&lang=js&"
import style0 from "./NewSliderImg.vue?vue&type=style&index=0&id=5c07efa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports